import { Component, OnDestroy, ChangeDetectionStrategy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subject } from "rxjs";
import { map, startWith, takeUntil } from "rxjs/operators";
import { AsyncPipe } from "@angular/common";
import { AllowedProtocolsCheckPipe } from "common/allowed-protocols-check.pipe";

interface CustomPolicyInformation {
	header?: string;
	text: string[];
	link?: string;
	linkName?: string;
}

enum PropertyType {
	HEADER = "header",
	TEXT = "text",
	LINK_HREF = "link.href",
	LINK_NAME = "link.name",
	BASE_STRING = "ai.general.legal.custom.",
}

@Component({
	selector: "stages-custom-ai-policy",
	templateUrl: "./custom-ai-policy.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [AsyncPipe, AllowedProtocolsCheckPipe],
})
export class CustomAiPolicyComponent implements OnDestroy {
	private destroy$ = new Subject<boolean>();
	protected customPolicyInfo$?: Observable<CustomPolicyInformation>;

	constructor(translateService: TranslateService) {
		this.customPolicyInfo$ = translateService.onLangChange.pipe(
			takeUntil(this.destroy$),
			startWith(null),
			map(() => {
				const currentLang = translateService.currentLang;
				const translations = translateService.translations;
				if (currentLang === undefined || translations === undefined) {
					return {
						header: undefined,
						text: [],
						link: undefined,
						linkName: undefined,
					};
				}
				const translationsInCurrentLanguage = (translations as never)[currentLang];
				const text = translationsInCurrentLanguage[PropertyType.BASE_STRING + PropertyType.TEXT];
				const link = translationsInCurrentLanguage[PropertyType.BASE_STRING + PropertyType.LINK_HREF];

				return {
					header: translationsInCurrentLanguage[PropertyType.BASE_STRING + PropertyType.HEADER],
					text: text ? (text as string).split("\n") : [],
					link: link,
					linkName: translationsInCurrentLanguage[PropertyType.BASE_STRING + PropertyType.LINK_NAME],
				};
			}),
		);
	}

	ngOnDestroy(): void {
		this.destroy$.next(true);
		this.destroy$.complete();
	}
}
